import { Store } from "redux";
import { AlightCustomSettingsType } from "../../settings/alight-custom-settings";
import { AlightStateType } from "../../types/alight-state";
import * as MinimiseActions from "../window-minimize/actions/actions";
import * as Actions from "./actions/actions";
import * as LaunchActions from '../window-launch/actions/actions';
import * as Reducers from "./reducers/index";
import { traceLog } from "../../src/logging";
import { sendRequest } from "@alme/ui-web/modules/lib-alme-request/src/lib-alme-request";
import {clearHistoryInState, clearHistoryInAgent} from "@alme/ui-web/ref/lib-end-session";

export default class EmbeddedIva {
  _settings: AlightCustomSettingsType;
  _store: Store<AlightStateType> | undefined;
  _embeddedStateAttribute = "embedded-state";

  constructor(settings: AlightCustomSettingsType) {
    this._settings = settings;
  }

  initialize(store: Store<AlightStateType>) {
    this._store = store;
  }

  getReducer() {
    return Reducers.reducer;
  }

  getPromise(): Promise<void> {
    return Promise.resolve();
  }

  getMutator() {
    return (parameters = {}) => {
      setTimeout(() => {
        const promise = new Promise(() => {
          const embedDiv = document.getElementById(
            this._settings.Window.embeddedRootId
          );

          if (embedDiv) {
            const hasEmbeddedState = embedDiv.hasAttribute(this._embeddedStateAttribute);
            if (!hasEmbeddedState) {
              this.embedIVA(embedDiv);
            }
            if (!this._store?.getState()?.Window.IsEmbedded) {
              const { IsEmbedded } = this._settings.stateLocations.Window;
              this._store?.dispatch(Actions.setEmbedded(true, IsEmbedded));
            }
          }
          else {
            // Ensure that IsEmbedded gets set to false when navigation to a non embedded page occurs. 
            if (this._store?.getState()?.Window.IsEmbedded) {
              this._settings.Window.rootId = this._settings.Window.standardRootId;
              const rootDiv = document.getElementById(
                this._settings.Window.rootId
              );
              if(rootDiv){
                this._settings.Window.enableFocusTrap = false;
                rootDiv.hidden = false;

                // repopulate history
                clearHistoryInState(this._store, this._settings);
                clearHistoryInAgent();
                const input = {
                  messageType: this._settings.messageConstants.getHistoryRequest,
                  messageLimit: this._settings.History.messageLimit,
                  includeRevertedEntries: this._settings.History.includeRevertedEntries,
                };
  
                sendRequest(input);
                const { IsEmbedded } = this._settings.stateLocations.Window;
                this._store?.dispatch(Actions.setEmbedded(false, IsEmbedded));
              }              
            }
          }
        });
        if (this._store?.getState()?.Window?.IsEmbedded) {
          if (document.getElementsByClassName('alme--window ui-draggable').length > 0) {
            let almewindow = document.getElementsByClassName('alme--window ui-draggable')[0] as HTMLElement;
            almewindow.style.display = 'block';
          }
          if (document.getElementsByClassName('alme--launchPointContainer').length > 0) {
            let launchPointContainer = document.getElementsByClassName('alme--launchPointContainer');
            for (let i = 0; i < launchPointContainer.length; i++) {
              let ele = launchPointContainer[i] as HTMLElement;
              ele.style.display = 'none';
            }
          }
        }

        if (!this._store?.getState()?.Window?.IsEmbedded) {
          promise
            .then(() => {
              traceLog("The IVA has been embedded", "embeddedIva.ts");
            })
            .catch((error) => {
              traceLog(error, "embeddedIva.ts");
            });
        }

      }, 1000);

      return parameters;
    };
  }

  embedIVA(embedDiv: HTMLElement): void {
    const { IsEmbedded } = this._settings.stateLocations.Window;
    this._store?.dispatch(Actions.setEmbedded(true, IsEmbedded));
    const oldRootName = this._settings.Window.rootId;
    const oldRoot = document.getElementById(oldRootName);

    if (oldRoot) {
      oldRoot.hidden = true;

      const embedAnchor = document.getElementById(this._settings.Window.embeddedRootId);

      oldRoot.childNodes.forEach(function (item) {
        embedAnchor?.appendChild(item.cloneNode(true));
      });
    }

    this._settings.Window.rootId = this._settings.Window.embeddedRootId;
    this._settings.Window.enableFocusTrap = false;


    const windowClass = this._settings.classNames.windowClassName;

    const windowElement = document.getElementsByClassName(
      windowClass
    )[0] as HTMLElement;

    if (windowElement != null && windowElement != undefined) {
      embedDiv.setAttribute("data-skinning", "embedded");
      embedDiv.setAttribute(this._embeddedStateAttribute, "true");
    }

    if (this._store?.getState()?.Window?.IsMinimized) {
      const { IsMinimized } = this._settings.stateLocations.Window;
    }

    this._store?.dispatch(LaunchActions.setLaunchPointName("SearchBarLaunch"));

  }
}



// WEBPACK FOOTER //
// ./modules/embedded-iva/embeddedIva.ts